module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-23"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Forgiveness"
    }
  }, [_c('h1', {
    staticClass: "chapter2",
    attrs: {
      "id": "pz23-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#ba_05",
      "id": "ab_05"
    }
  }, [_c('b', [_vm._v("Forgiveness")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-3"
    }
  }, [_vm._v("To the praise of the glory of His grace, by which He made us accepted in the Beloved.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-4"
    }
  }, [_vm._v("In Him we have redemption through His blood, the forgiveness of sins, according to the riches of His grace.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz23-5"
    }
  }, [_c('em', [_vm._v("Ephesians 1:6, 7")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-6"
    }
  }, [_vm._v("You have forgiven the iniquity of Your people;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-7"
    }
  }, [_vm._v("You have covered all their sin. Selah")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz23-8"
    }
  }, [_c('em', [_vm._v("Psalm 85:2")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-9"
    }
  }, [_vm._v("Therefore, if anyone is in Christ, he is a new creation; old things have passed away; behold, all things have become new.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz23-10"
    }
  }, [_c('em', [_vm._v("II Corinthians 5:17")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-11"
    }
  }, [_vm._v("As far as the east is from the west,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-12"
    }
  }, [_vm._v("So far has He removed our transgressions from us.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz23-14"
    }
  }, [_c('em', [_vm._v("Psalm 103:12")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-15"
    }
  }, [_vm._v("My little children, these things I write to you, so that you may not sin. And if anyone sins, we have an Advocate with the Father, Jesus Christ the righteous.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz23-16"
    }
  }, [_c('em', [_vm._v("1 John 2:1")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-1"
    }
  }, [_vm._v("If we confess our sins, He is faithful and just to forgive us our sins and to cleanse us from all unrighteousness.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz24-2"
    }
  }, [_c('em', [_vm._v("1 John 1:9")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-3"
    }
  }, [_vm._v("For I will be merciful to their unrighteousness, and their sins and their lawless deeds I will remember no more.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz24-4"
    }
  }, [_c('em', [_vm._v("Hebrews 8:12")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-5"
    }
  }, [_vm._v("Let the wicked forsake his way,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-6"
    }
  }, [_vm._v("And the unrighteous man his thoughts;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-7"
    }
  }, [_vm._v("Let him return to the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-8"
    }
  }, [_vm._v("And He will have mercy on him;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-9"
    }
  }, [_vm._v("And to our God,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-10"
    }
  }, [_vm._v("For He will abundantly pardon.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz24-11"
    }
  }, [_c('em', [_vm._v("Isaiah 55:7")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-12"
    }
  }, [_vm._v("Bearing with one another, and forgiving one another, if anyone has a complaint against another; even as Christ forgave you, so you also must do.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AMbb"
    }
  }, [_c('em', [_vm._v("Colossians 3:13")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-13"
    }
  }, [_vm._v("And whenever you stand praying, if you have anything against anyone, forgive him, that your Father in heaven may also forgive you your trespasses.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz24-14"
    }
  }, [_c('em', [_vm._v("Mark 11:25")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-1"
    }
  }, [_vm._v("And you, being dead in your trespasses and the uncircumcision of your flesh, He has made alive together with Him, having forgiven you all trespasses.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "An1q"
    }
  }, [_c('em', [_vm._v("Colossians 2:13")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-2"
    }
  }, [_vm._v("I will cleanse them from all their iniquity by which they have sinned against Me, and I will pardon all their iniquities by which they have sinned and by which they have transgressed against Me.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "AOb"
    }
  }, [_c('em', [_vm._v("Jeremiah 33:8")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-3"
    }
  }, [_vm._v("“Come now, and let us reason together,” says the L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORD")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-4"
    }
  }, [_vm._v("“Though your sins are like scarlet,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-5"
    }
  }, [_vm._v("They shall be as white as snow;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-6"
    }
  }, [_vm._v("Though they are red like crimson,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-7"
    }
  }, [_vm._v("They shall be as wool.”")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz25-8"
    }
  }, [_c('em', [_vm._v("Isaiah 1:18")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-9"
    }
  }, [_vm._v("I, even I, am He who blots out your transgressions for My own sake;")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-10"
    }
  }, [_vm._v("And I will not remember your sins.")]), _vm._v(" "), _c('p', {
    staticClass: "right",
    attrs: {
      "id": "pz25-11"
    }
  }, [_c('em', [_vm._v("Isaiah 43:25")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7abb66a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter05.vue
// module id = 87
// module chunks = 0